module.exports = __webpack_public_path__ + "/hashedassets-launcher/illustration.87223b841b9b77c827d6378d7a878863.svg";